import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AdlSecondCardData, AdlSummaryIDO } from 'src/app/core/models/admin';
import { HEADER_TEXT } from './adl-summary.constants';

@Component({
  selector: 'app-adl-summary',
  templateUrl: './adl-summary.component.html',
  styleUrls: ['./adl-summary.component.scss'],
  standalone: false,
})
export class AdlSummaryComponent implements OnInit {
  readonly HEADER = HEADER_TEXT;

  contactCardData: string[][] = [];
  indicatorCardData: boolean[] = [];
  availabilityCardData: AdlSecondCardData = {
    availableDays: [
      [
        {
          status: '',
          times: { start: '', end: '' },
          effectiveDate: '',
        },
      ],
    ],
    closeDays: [{ start: '', end: '' }],
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AdlSummaryIDO,
    private dialogRef: MatDialogRef<AdlSummaryComponent>,
  ) {}

  ngOnInit(): void {
    const firstData = Object.values(this.data.firstCardData);

    this.contactCardData.push(firstData?.slice(0, 3));
    this.contactCardData.push(firstData?.slice(3, 8));
    this.contactCardData.push(firstData?.slice(8, 10));

    this.availabilityCardData = this.data.secondCardData;
    this.indicatorCardData = this.data.thirdCardData;
  }

  clickExit() {
    this.dialogRef.close();
  }
}
